@if (hasDetails) {
  <div class="ion-text-left question" [hidden]="hideDetails">
    <details
      [attr.id]="'details' + model.position + '-' + loopIndex"
      (toggle)="toggleBlock()"
    >
      <summary
        [attr.id]="'summary' + model.position + '-' + loopIndex"
        [hidden]="hideDetails"
      >
        {{ model.text }}
      </summary>
      @for (i of numberOfRepetitions; track $index) {
        <span
          [attr.id]="'content' + model.position + '-' + loopIndex"
        >
          @for (element of model.elements; track $index) {
            <app-element
              [init]="element"
              [loopIndex]="loopIndex * model.repeat.data + i - 1"
              [hidden]="hideElements || hideDetails"
            >
            </app-element>
          }
        </span>
      }
    </details>
  </div>
} @else {
  <div>
    @for (i of numberOfRepetitions; track $index) {
      <span>
        @for (element of model.elements; track $index) {
          <app-element
            [init]="element"
            [loopIndex]="loopIndex * model.repeat.data + i - 1"
            [hidden]="hideElements"
          >
          </app-element>
        }
      </span>
    }
  </div>
}
